import { configureStore } from '@reduxjs/toolkit'
import currentReducer from './states/currentstate'
import noteReducer from './states/noteState'
export default configureStore({
  reducer: {
    current: currentReducer,
    note: noteReducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})